/// <reference path="../../components/webComponents/services/webComponentSetup.service.ts" />

/**
 * QuickSight Dashboard Viewer — Web Component Registration for Performance Insights
 *
 * Registers the <meevo-qs-dashboard-viewer> web component on the Performance
 * Insights module. Uses a distinct registration id and a distinct DOM mount
 * container id so both this plugin and the Reports plugin can coexist in the
 * same session without colliding (though reports no longer hosts QuickSight).
 */
angular.module('meevo.plugins.performanceInsights').run([
    'webComponentSetup',
    '$rootScope',
    'meevo.components.common.IdentityService',
    function (
        webComponentSetup: any,
        $rootScope: angular.IRootScopeService,
        identityService: Meevo.Components.Common.IIdentityService
    ) {
        webComponentSetup.register({
            id: 'qs-dashboard-viewer',
            tag: 'meevo-qs-dashboard-viewer',
            scriptPath: '/lib/meevo-qs-dashboard-viewer.js',
            preMountProps: function () {
                return {
                    isMsiUser: identityService.current().userTypeEnum === Meevo.Model.UserTypeEnum.MSIUser,
                };
            },
            onMount: function (element: any) {
                var container = document.getElementById('qs-dashboard-mount-container');
                if (!container) { return; }

                var viewerReadyHandler = function () {
                    $rootScope.$broadcast('performanceInsights:qs-ready');
                };
                element.addEventListener('qs-ready', viewerReadyHandler);

                var dashboardIds = container.getAttribute('data-dashboard-ids');
                var initialDashboardId = container.getAttribute('data-initial-dashboard-id');

                if (dashboardIds) {
                    element.setAttribute('dashboard-ids', dashboardIds);
                }
                if (initialDashboardId) {
                    element.setAttribute('initial-dashboard-id', initialDashboardId);
                }
                // The element is created once and kept alive via ng-show as the user
                // navigates back to the dashboard list and picks another dashboard, so
                // the initial mount-time copy above only reflects the FIRST dashboard.
                // Watch the container's data-initial-dashboard-id (bound to
                // selectedReport.id) and forward changes onto the live element so the
                // component's ngOnChanges fires switchDashboard(). NOTE: switching
                // currently re-embeds a fresh QS session (a new paid session per
                // switch) rather than a free in-session navigate — the embed session's
                // row-level security only covers the initially-embedded dashboard, so
                // an in-session navigate would leak RLS-protected data. See
                // switchDashboard() in the web component for the full rationale.
                var observer = new MutationObserver(function () {
                    var next = container.getAttribute('data-initial-dashboard-id');
                    if (next && next !== element.getAttribute('initial-dashboard-id')) {
                        // Set BOTH the attribute (for consistency) and the property.
                        // The property is the reliable Angular Elements input path —
                        // it's how the mount directive injects hostBridge/api — whereas
                        // attribute→input relies on observedAttributes/attributeChangedCallback.
                        element.setAttribute('initial-dashboard-id', next);
                        element.initialDashboardId = next;
                    }
                });
                observer.observe(container, {
                    attributes: true,
                    attributeFilter: ['data-initial-dashboard-id'],
                });
                // Stashed on the element so the unmount hook can disconnect it.
                element.__qsInitialDashboardIdObserver = observer;
                element.__qsViewerReadyHandler = viewerReadyHandler;
            },
            onUnmount: function (element: any) {
                var observer = element.__qsInitialDashboardIdObserver;
                if (observer) {
                    observer.disconnect();
                    element.__qsInitialDashboardIdObserver = null;
                }
                if (element.__qsViewerReadyHandler) {
                    element.removeEventListener('qs-ready', element.__qsViewerReadyHandler);
                    element.__qsViewerReadyHandler = null;
                }
            }
        });
    }
]);
